// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__C7cTd","title":"ClientCherryInfo_title__2AJAy","itemText":"ClientCherryInfo_itemText__1DIBe"};